const number = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const listProducts = (categories) =>
  (Array.isArray(categories) ? categories : []).flatMap((category) =>
    Array.isArray(category?.products) ? category.products : [],
  );

const countXReportArticles = (categories) =>
  listProducts(categories)
    .filter((product) => String(product?.type || "product").toLowerCase() !== "extra")
    .reduce((sum, product) => sum + number(product?.quantity), 0);

const sumXReportCategoryTotals = (categories) =>
  (Array.isArray(categories) ? categories : []).reduce(
    (sum, category) => sum + number(category?.total),
    0,
  );

module.exports = { countXReportArticles, sumXReportCategoryTotals };
